import api from '../api';

export class CommissionRulesManagementUpdate {
    static getCommissionRulesUpdate(payload: any) {
        return api.putApiCall('/api/v1/admins/commissions', {
         commissionId: payload.commissionId,
         percentage: payload.percentage,
        });
      }
}